import ImagesIconsCommonGooglePlayColoredSvg from '@/public/images/icons/common/google-play-colored.svg';

export { ImagesIconsCommonGooglePlayColoredSvg };
